<div class="m-5 w-[95%]">
  <div *ngIf="sampleCases.length > 0 && !review">
    <b>Example:</b><br/>
    <b>Input: </b>
    <span *ngFor="let arg of argumentNames, index as i; let last = last">
      {{arg}} = 
      <span [innerHTML]="sampleCases[0].input[i]"></span>
      <span *ngIf="!last">,</span>
    </span>
    <br/>
    <b>Output: </b>
    <pre>{{sampleCases[0].outputExpected.join('\n')}}</pre>
  </div>
  <div class="mb-3 grid grid-cols-2 gap-3">
    <div></div>
    <div class="flex justify-end items-center" *ngIf="!review">
      <b>
        <span *ngIf="samplesRemaining < 0" class="animate-pulse bg-gray-200 rounded-[6px] w-[10px] h-[21px]"></span>
        <span *ngIf="samplesRemaining >= 0">{{samplesRemaining}}</span>
        Attempt<span *ngIf="samplesRemaining !== 1">s</span> left
      </b>
      <button
        class="ml-3 rounded-[6px] border border-[#D9D9D9] text-[#167726] font-semibold px-[16px] py-[8px] text-[14px] flex items-center max-w-[74px]"
        (click)="runClick()"
      >
        <svg *ngIf="isLoading"viewBox="25 25 50 50" class="mr-1">
          <circle r="20" cy="50" cx="50"></circle>
        </svg>
        <fa-icon *ngIf="!isLoading" [icon]="faPlay" class="mr-1" />
        Run
      </button>
    </div>
    <b>Language</b>
    <b>Theme</b>
    <div>Java</div>
    <select
      (change)="changeTheme($event)"
      class="block rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6">
      <option value="vs-light" selected>Light</option>
      <option value="vs-dark">Dark</option>
      <option value="hc-light">High Contrast Light</option>
      <option value="hc-black">High Contrast Dark</option>
    </select>
  </div>
  <ngx-monaco-editor class="my-code-editor" [options]="editorOptions" [(ngModel)]="code" (change)="onChange(code)" (onInit)="onInit($event)"></ngx-monaco-editor>
  <code-output [theme]="theme" [result]="codeResult" />
</div>
